<template>
    <div>
        <commonheader :activeNavIdx="parseInt(this.$route.query.currentNavIndex)"></commonheader>
        <div class="content el-container-master">
            <!-- <div class="crumbsNavCont">
                <p class="crumbsNav">位置：首页>{{breadcrumbText[this.$route.query.currentNavIndex-2]}}</p>
            </div> -->
            <div class="detail">
                <div class="associationNewDetailCont" v-loading='loading'>
                    <div v-if="Object.keys(newDetailData).length > 0">
                        <h2 class="detailTitle">{{newDetailData.title}}</h2>
                        <!-- <p class="publishTime">发布时间: {{newDetailData.published_time}}</p> -->

                        <div class="paragraphList" v-html="newDetailData.content"></div>
                    </div>
                </div>
                <div class="contactUsBox fr">
                    <contactus :contactStyle2="true"></contactus>
                </div>
            </div>
        </div>
        <commonfooter></commonfooter>
    </div>
</template>

<script>
import commonheader from './common/commonHeader.vue' //头部组件
import commonfooter from './common/commonFooter.vue' //底部组件
import contactus from './common/contactUs.vue' //右侧联系我们组件
import { mapState } from "vuex";
export default {
    components: {
        commonheader,
        commonfooter,
        contactus,
    },
    data () {
        return {
            loading: true,
            newDetailData: {},
        };
    },

    computed: {
        // ...mapState({
        //     navCategoryListData: state => state.index.navCategoryListData,
        // }),
    },
    watch: {
        'newDetailData': {
            handler: function (val, oldVal) {
                this.newDetailData = val
            },
            deep: true
        },
    },
    mounted () {

        // let navCategoryPageParams = {
        //     postid: this.$route.query.postid
        // }
        // let api = this.apiCategory(this.$route.query.postid);
        let params={}
        if(this.$route.query.id){
          params.id=this.$route.query.id
        }
        console.log(this.$route.query.api, params)
        this.$store.dispatch(this.$route.query.api, params).then((res) => {
          console.log(res)
            if (res.code == 200) {
                if (res.data) {
                    this.newDetailData = res.data
                }
            }
            this.loading = false;
        }).catch(error => {
            this.loading = false;
            console.error('错误信息：', error)
        })
    },
    methods: {

    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@media (min-width: 1399px) {
    .el-container-master {
        width: 1200px;
        margin: auto;
    }
}
.content {
    margin: 0 auto;
    padding-bottom: 50px;
}
.detail{
    position: relative;
}
.crumbsNavCont {
    height: 70px;
    border-bottom: 1px solid #d8d8d8;
    position: relative;
}
.crumbsNav {
    font-size: 14px;
    color: #222;
    height: 100%;
    line-height: 70px;
}

.associationNewDetailCont {
    width: 880px;
    min-height: 700px;
    overflow: hidden;
}

.detailTitle {
    text-align: center;
    margin-top: 25px;
    font-weight: bold;
    /* width: 70%; */
    margin: 25px auto 0;
    font-size: 18px;
}

.publishTime {
    text-align: center;
    color: #999;
    font-size: 14px;
    margin-top: 20px;
}

.paragraphList {
    width: 100%;
    margin: 0 auto;
    padding-top :30px;
}

.paragraphList > p {
    margin-top: 35px;
    font-size: 16px;
    color: #333;
    line-height: 32px;
    text-indent: 40px;
}
.paragraphList > p > img {
    display: block;
    max-width: 100%;
    margin: 0 auto;
}
.contactUsBox {
    width: 265px;
    position: absolute;
    right: 0;
    top: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/newDetail.vue